import React from 'react';
import TPiece, { TPieceCart } from '../types/TPiece';

const OrderProvider = React.createContext<[TPieceCart[], any]>([[], {}]);

export default OrderProvider;